import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import RateModel from "../../viewModels/Rate/RateModel";
import { OpenRateHistoryModalPayload, RateHistoryTab } from "./types";

type RateHistoryModalState = {
  open: boolean;
  rateId?: number;
  calculationVehicleId?: number;
  carrierName?: string;
  activeTab: RateHistoryTab;
  items: Array<RateModel>;
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  loadingMore: boolean;
  error: boolean;
  createError: boolean;
  creatingRateId?: number;
};

const getInitialState = (): RateHistoryModalState => ({
  open: false,
  activeTab: "SELECTED_SERVICES",
  items: [],
  total: 0,
  page: 1,
  pageSize: 10,
  loading: false,
  loadingMore: false,
  error: false,
  createError: false,
});

const rateHistoryModalSlice = createSlice({
  name: "rateHistoryModal",
  initialState: getInitialState(),
  reducers: {
    openModal(state, action: PayloadAction<OpenRateHistoryModalPayload>) {
      state.open = true;
      state.rateId = action.payload.rateId;
      state.calculationVehicleId = action.payload.calculationVehicleId;
      state.carrierName = action.payload.carrierName;
      state.activeTab = "SELECTED_SERVICES";
      state.items = [];
      state.total = 0;
      state.page = 1;
      state.loading = true;
      state.loadingMore = false;
      state.error = false;
      state.createError = false;
      state.creatingRateId = undefined;
    },
    closeModal(state) {
      Object.assign(state, getInitialState());
    },
    changeTab(state, action: PayloadAction<RateHistoryTab>) {
      state.activeTab = action.payload;
      state.items = [];
      state.total = 0;
      state.page = 1;
      state.loading = true;
      state.loadingMore = false;
      state.error = false;
      state.createError = false;
    },
    loadMore(state) {
      if (!state.loading && !state.loadingMore && state.items.length < state.total) {
        state.loadingMore = true;
        state.error = false;
      }
    },
    retryLoad(state) {
      state.error = false;
      state.loading = state.items.length === 0;
      state.loadingMore = state.items.length > 0 && state.items.length < state.total;
    },
    loadHistorySuccess(state, action: PayloadAction<{ items: Array<RateModel>; total: number; page: number; append: boolean }>) {
      state.items = action.payload.append ? [...state.items, ...action.payload.items] : action.payload.items;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.loading = false;
      state.loadingMore = false;
      state.error = false;
    },
    loadHistoryReject(state) {
      state.loading = false;
      state.loadingMore = false;
      state.error = true;
    },
    createWishElementByRate(state, action: PayloadAction<{ rateId: number }>) {
      if (!state.calculationVehicleId) return;
      state.creatingRateId = action.payload.rateId;
      state.createError = false;
    },
    createWishElementByRateSuccess(state) {
      Object.assign(state, getInitialState());
    },
    createWishElementByRateReject(state) {
      state.creatingRateId = undefined;
      state.createError = true;
    },
  },
});

export default rateHistoryModalSlice;
